/**
 * ContentVisual.js
 * 
 * Displays the visual for the Content section.
 * Extracted from legacy MainRight.js logic using IlAdd active="co".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const ContentVisual = ({ lower }) => {
  if (lower === "left") {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/content/contents-left.jpeg")`}}></div>);		
  } else if (lower === "right") {
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/content/contents-right.jpeg")`}}></div>);		
  } else {
    // Default or "upper" case
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/content/contents-upper.jpeg")`}}></div>);		
  }
};
